import CoachExpertise from '@/components/shared/CoachExpertise/CoachExpertise';
import Paper from '@/components/shared/Paper/Paper';
import { Text } from '@/components/shared/Text/Text';
import { Coach } from '@addmile/backend-client';

interface CoachInfoProps {
  coachData?: Coach;
  sessions: {
    [key: string]: number;
  };
}

const CoachInfo = ({ coachData, sessions }: CoachInfoProps) => {
  const { Booked, Completed, Skipped } = sessions;

  return (
    <Paper className="my-4 w-[461px]">
      <div className="mt-4 flex items-center font-bold pb-2 gap-4">
        <img
          src={coachData?.photoUrl ? coachData.photoUrl : '/icons/avatar.svg'}
          alt="Avatar"
          className="w-16 h-16 rounded-full object-cover"
        />

        <Text.Bigger weight="bold">{coachData?.name}</Text.Bigger>
      </div>
      <div className="mt-4 flex items-center font-bold pb-2 gap-4">
        <Text.Regular weight="bold">Timezone:</Text.Regular>
        <span className="mr-16 text-lg font-medium">{coachData?.timezone}</span>
      </div>

      <div className="mt-4 flex items-start font-bold pb-2 gap-4 border-b border-neutral-10 ">
        <Text.Regular weight="bold">Expertise:</Text.Regular>
        <div className="flex flex-wrap gap-2">
          {coachData?.expertise.map((expertise) => (
            <CoachExpertise key={expertise} expertise={expertise} />
          ))}
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between font-bold">
        <Text.Normal weight="bold">Booked:</Text.Normal>
        <span className="mr-16 text-lg font-medium">{Booked}</span>
      </div>
      <div className="flex items-center justify-between font-bold pt-2">
        <Text.Normal weight="bold">Completed:</Text.Normal>
        <span className="mr-16 text-lg font-medium">{Completed}</span>
      </div>
      <div className="flex items-center justify-between font-bold pt-2">
        <Text.Normal weight="bold">Skipped:</Text.Normal>
        <span className="mr-16 text-lg font-medium">{Skipped}</span>
      </div>
    </Paper>
  );
};

export default CoachInfo;
